export default ({ value, isCheckStringNull = false, isCheckNumberNull = false }) => {
  return value === undefined || value === null || (isCheckStringNull && value === '') || (isCheckNumberNull && value === 0);
};
